class SearchResults extends HTMLElement {
  constructor() {
    super();
    this.init();
    this.addEventListeners();
  }
  init = () => {
    this.SELECTORS = {
      suggested: ".suggested button",
      input: ".search-input",
      fetchProducts: ".products product-card",
      productWrapper: ".product-results",
      showMore: ".show-more",
      searchText: ".search-text strong",
      clearButton: ".clear.btn",
      faqResults: ".faq-results",
      faqContent: ".faq-content",
      articles: ".articles",
      productCountText: ".product-count i",
      faqCountText: ".faq-count i",
      resultsCount: ".results_count",
      bestSelling: ".best-selling-container",
      fetchBestSelling: ".best-selling > product-card",
      faqCarosel: "carosel-component.faq-carosel",
      bestSellingCarosel: "carosel-component.best-selling-carosel",
    };
    this.productCount = this.dataset.productCount ?? 6;
    this.page = 1;
    this.requests = 0;
    this.hasFAQ = true;
    this.hasProducts = true;
    this.setBestSelling = false;

    this.suggested = [...this.querySelectorAll(this.SELECTORS.suggested)];
    this.input = this.querySelector(this.SELECTORS.input);
    this.productWrapper = this.querySelector(this.SELECTORS.productWrapper);
    this.showMore = this.querySelector(this.SELECTORS.showMore);
    this.searchText = this.querySelector(this.SELECTORS.searchText);
    this.clearButton = this.querySelector(this.SELECTORS.clearButton);
    this.faqResults = this.querySelector(this.SELECTORS.faqResults);
    this.faqCountText = this.querySelector(this.SELECTORS.faqCountText);
    this.productCountText = this.querySelector(this.SELECTORS.productCountText);
    this.bestSelling = this.querySelector(this.SELECTORS.bestSelling);
    this.faqCarosel = this.querySelector(this.SELECTORS.faqCarosel);
    this.bestSellingCarosel = this.querySelector(
      this.SELECTORS.bestSellingCarosel
    );
    this.fetchData("", true);
  };
  removeTagsExceptAnchor(text) {
    return text.replace(/<(?!\/?a)([^>]*?)>/g, "");
  }
  addEventListeners = () => {
    this.suggested.map((x) => {
      x.addEventListener("click", () => {
        this.suggest(x);
      });
    });
    this.input.addEventListener("keyup", (e) => {
      if (e.keyCode == 9) return;
      this.searchTimeout(!(e.key === "Enter" || e.keyCode === 13));
    });
    this.showMore.addEventListener("click", (e) => {
      this.page++;
      this.fetchData(this.input.value);
    });
    this.clearButton.addEventListener("click", () => {
      this.input.value = "";
      this.search(true);
    });
  };
  suggest = (x) => {
    this.input.value = x.textContent;
    this.search();
  };
  getHtml = async (data) => {
    if (data.status !== 200) throw new Error("Error fetching.");
    return new DOMParser().parseFromString(await data.text(), "text/html");
  };
  fetchProducts = async (req, query, refresh) => {
    try {
    const localePrefix = window.Shopify.routes.root; // Automatically gives "/ar/" for Arabic, "/" for English
    const newUrl = `${localePrefix}search?q=${
    !query
    ? window.Shopify.search_hash
    : `-tag:child_product ${query}`
    }&page=${this.page}&type=product`;
      // const newUrl = `/search?q=${
      //   !query
      //     ? window.Shopify.search_hash
      //     : `-tag:child_product ${query}`
      // }&page=${this.page}&type=product`;
      const data = await fetch(newUrl, req);
      const html = await this.getHtml(data);
      console.log(newUrl,'new url');
      const cards = html.querySelectorAll(this.SELECTORS.fetchProducts);
      if (refresh) {
        this.productWrapper.innerHTML = "";
      }
      cards.length < this.productCount
        ? this.showMore.classList.add("hide")
        : this.showMore.classList.remove("hide");
      this.hasProducts = !!cards.length;
      this.productWrapper.append(...[...cards].map((x) => x.cloneNode(true)));
      this.productCountText.textContent =
        +html.querySelector(this.SELECTORS.resultsCount)?.value || "";
      this.input.value
        ? this.classList.add("searching")
        : this.classList.remove("searching");
    } catch (err) {
      console.error(err);
    } finally {
      this.fetchDone();
    }
  };
  fetchFAQ = async (req, query) => {
    try {
      const newUrl = `/search?q=${
        !query ? window.Shopify.search_hash : query
      }&page=${this.page}&type=article`;
      const data = await fetch(newUrl, req);
      const html = await this.getHtml(data);
      const articles = html.querySelector(this.SELECTORS.articles);
      const faqContent = [
        ...articles.querySelectorAll(this.SELECTORS.faqContent),
      ];
      faqContent.map((content) => {
        content.innerHTML = this.removeTagsExceptAnchor(content.innerHTML);
      });
      const faqBoxes = articles.querySelectorAll(".faq-box");
      faqBoxes.forEach((el) => el.classList.add("swiper-slide"));
      this.hasFAQ = !!faqContent.length;
      this.faqResults.innerHTML = "";
      this.faqResults.append(...faqBoxes);
      this.faqCarosel.swiper.update();
      // if (faqContent.length === 0 && this.page === 1) {
      //   this.searchText.textContent = this.input.value;
      //   this.classList.add("no-results");
      // } else {
      //   this.classList.remove("no-results");
      // }
      this.faqCountText.textContent =
        +html.querySelector(this.SELECTORS.resultsCount)?.value || "";
      if (!this.setBestSelling) {
        this.bestSelling.append(
          ...html.querySelectorAll(this.SELECTORS.fetchBestSelling)
        );
        this.setBestSelling = true;
        this.bestSellingCarosel.swiper.update();
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.fetchDone();
    }
  };
  fetchDone = () => {
    this.requests--;
    if (this.requests === 0) {
      if (this.hasProducts || this.hasFAQ) {
        this.classList.remove("no-results");
      } else {
        this.searchText.textContent = this.input.value;
        this.classList.add("no-results");
      }
    }
  };
  fetchData = (query = "", refresh) => {
    if (refresh) this.page = 1;
    const req = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    };
    this.requests++;
    this.fetchProducts(req, query, refresh);
    if (refresh) {
      this.requests++;
      this.fetchFAQ(req, query);
    }
  };
  search = async (initial = false) => {
    this.fetchData(this.input.value, true);
  };
  searchTimeout = (hasDelay) => {
    this.timeout && clearTimeout(this.timeout);
    if (this.input.value === "") {
      this.search(true);
    }
    if (hasDelay) {
      this.timeout = setTimeout(() => {
        this.search();
      }, 200);
    } else {
      this.search();
    }
  };
}
customElements.define("search-results", SearchResults);
